import type { SVGProps } from "react";

const SvgKbLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 97 32" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.19 16h32V0h-32z"
      fill="#E60028"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M.19 32h32V16h-32z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.76 16.976h20.86v-1.952H5.76z"
      fill="#FFFFFE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.942 25.656V6.52h3.547v8.93l9.619-8.93h4.362l-9.898 9.21 10.307 9.925h-4.771l-9.62-9.287v9.287zm36.313-5.613c0-1.608-.842-2.474-2.653-2.474h-9.516v4.923h9.083c2.118 0 3.086-.918 3.086-2.45m-2.883-5.639c1.608 0 2.348-1.122 2.348-2.321 0-1.327-.842-2.398-2.551-2.398h-9.083v4.72zm3.904 1.327c1.684.867 2.653 2.474 2.653 4.312 0 3.164-2.295 5.613-6.684 5.613h-12.68V6.52H75.17c3.52 0 6.071 2.143 6.071 5.383 0 1.659-.713 2.858-1.964 3.827"
    />
  </svg>
);
export default SvgKbLogo;
